// RefsContext.js
import React, { createContext, useRef } from "react";
const defaultRefs = {
  homeRef: { current: null },
  aboutRef: { current: null },
  servicesRef: { current: null },
};
export const RefsContext = createContext(defaultRefs);

export const RefsProvider = ({ children }) => {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);

  return (
      <RefsContext.Provider value={{ homeRef, aboutRef, servicesRef }}>
        {children}
      </RefsContext.Provider>
  );
};
